import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAuthorizedUrls } from '../utils/menuBuilder';

const ProtectedRoute = ({ children }) => {
  const { user, modules, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Replace with proper loader if available
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Define URLs that are always accessible (like profile, dashboard-redirects, etc.)
  const publicModules = ['/', '/dashboard', '/Setting']; // Adjust as needed
  
  const authorizedUrls = getAuthorizedUrls(modules);
  const currentPath = location.pathname.toLowerCase();

  const isAuthorized = publicModules.some(url => url.toLowerCase() === currentPath) || 
                       authorizedUrls.has(currentPath);

  if (!isAuthorized) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>Access Denied</h1>
        <p>You do not have permission to view this page.</p>
        <button onClick={() => window.location.href = '/dashboard'}>Go to Dashboard</button>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
